import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { alertProgressMsg, alertSuccessMsg, executeStored } from '../Utils';
import useSettings from '../hooks/useSettings';
import useUserData from '../hooks/useUserData';
import Form from '../Form';
import SimpleTextField from '../fields/SimpleTextField';

interface DocumentSettingsEditDialogProps {
	module: string;
	docsFolderPath: string;
	itemUid: string;
	folderName: string;
	updateRefresh: VoidFunction;
}

export const showDocumentSettingsEditDialog = (props: DocumentSettingsEditDialogProps) =>
	openDialog({ children: <DocumentSettingsEditDialog {...props} />, maxWidth: 'sm', fullWidth: true });

export default function DocumentSettingsEditDialog(props: DocumentSettingsEditDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(props.module);
	const userData = useUserData();

	const [newFolderName, setNewFolderName] = React.useState<string | null>(props.folderName);

	function submitSave() {
		dispatch(alertProgressMsg(t));
		executeStored({
			action: `st_${props.module}_update`,
			dispatch,
			data: {
				[`${settings.modu_short}_uid`]: props.itemUid,
				[`${settings.modu_short}_user_modified_uid`]: userData.user_uid,
				[`${settings.modu_short}_foldername`]: newFolderName
			},
			successHandler: response => {
				dispatch(alertSuccessMsg(t));
				dispatch(closeDialog());
				props.updateRefresh();
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('DOCUMENTS_SETTINGS_DIALOG_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="documentsSettingsDialog" onSubmit={submitSave}>
					<Grid container spacing={2}>
						<Grid size={12}>
							<Typography>{t('DOCUMENTS_SETTINGS_DIALOG_DESCRIPTION1')}</Typography>
						</Grid>
						<Grid size={12}>
							<Typography>{t('DOCUMENTS_SETTINGS_DIALOG_DESCRIPTION2')}</Typography>
						</Grid>
						<Grid size={12}>
							<SimpleTextField
								name="folderName"
								label={t('DOCUMENTS_SETTINGS_DIALOG_FIELD_FOLDERNAME')}
								value={props.folderName}
								isEdit
								sendChange={(_name, value) => setNewFolderName(value)}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						</Grid>
						<Grid size={12}>
							<Typography variant="subtitle2">{t('DOCUMENTS_SETTINGS_DIALOG_CURRENTPATH')}</Typography>
							<Typography className="break-words">{`${props.docsFolderPath}${newFolderName}`}</Typography>
						</Grid>
					</Grid>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="documentsSettingsDialog" color="secondary">
					{t('DIALOG_ACTION_SAVE')}
				</Button>
			</DialogActions>
		</>
	);
}
